import { render } from "./totalEarning1.vue?vue&type=template&id=22e04c86"
import script from "./totalEarning1.vue?vue&type=script&lang=js"
export * from "./totalEarning1.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__